import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { addAmounts, subtractAmounts, multiplyAmount, lamports } from '../../types/Amount.mjs';

const TRANSACTION_FEE = 5000;
class UtilsClient {
  constructor(metaplex) {
    _defineProperty(this, "cachedRentPerEmptyAccount", null);

    _defineProperty(this, "cachedRentPerByte", null);

    this.metaplex = metaplex;
  }

  async estimate(bytes, numberOfAccounts = 1, numberOfTransactions = 1, useCache = true) {
    const rent = await this.estimateRent(bytes, numberOfAccounts, useCache);
    const transactionFees = this.estimateTransactionFee(numberOfTransactions);
    return addAmounts(rent, transactionFees);
  }

  async estimateRent(bytes, numberOfAccounts = 1, useCache = true) {
    if (!useCache || this.cachedRentPerEmptyAccount === null || this.cachedRentPerByte === null) {
      const rentFor0Bytes = await this.metaplex.rpc().getRent(0);
      const rentFor1Byte = await this.metaplex.rpc().getRent(1);
      this.cachedRentPerEmptyAccount = rentFor0Bytes;
      this.cachedRentPerByte = subtractAmounts(rentFor1Byte, rentFor0Bytes);
    }

    const rentForAccounts = multiplyAmount(this.cachedRentPerEmptyAccount, numberOfAccounts);
    const rentForBytes = multiplyAmount(this.cachedRentPerByte, bytes);
    return addAmounts(rentForAccounts, rentForBytes);
  }

  estimateTransactionFee(numberOfTransactions = 1) {
    // TODO(loris): Improve with an RPC call to get the current transaction fee.
    return lamports(numberOfTransactions * TRANSACTION_FEE);
  }

}

export { UtilsClient };
//# sourceMappingURL=UtilsClient.mjs.map
